import { PriceValue } from '@secretescapes/cauldron';
import styled, {
  BoxShadows,
  Device,
  Scale,
  TypographyVariant,
  boxShadows,
  breakpoints,
  typographyVariantProperties,
} from '@secretescapes/falcon';
import { mediaQuery } from '@utils/styles.utils';
import { LoadingSkeletonSection } from '@features/AvailabilityPresentation/LoadingSkeleton/LoadingSkeleton';

interface TileProps {
  isBookable: boolean;
}

interface CardProps {
  isDisabled: boolean;
}

export const Tile = styled('div')<TileProps>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.white};
  border: ${({ theme }) => `${theme.color.grey10} 1px solid`};
  /*border radius set to 5px due to tiny white gap between image and border if set at 4px */
  border-radius: 5px;
  ${({ isBookable }) => isBookable && `box-shadow: ${boxShadows[BoxShadows.level2]}`};

  .carousel__image {
    border-radius: ${Scale.xxs} ${Scale.xxs} 0 0;
    aspect-ratio: 2 / 1;
    object-fit: cover;
  }
`;

export const Card = styled('div')<CardProps>`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
  padding: ${Scale.m};
  height: 100%;
  ${({ isDisabled }) =>
    isDisabled && '> div > :not(.unavailable-message) { opacity: 0.5; pointer-events: none; }'};

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    padding: ${Scale.l};
  }
`;

export const Header = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xs};
`;

export const Actions = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
  margin-top: auto;
`;

export const OccupancyContainer = styled('div')`
  display: flex;
  gap: ${Scale.m};
  flex-wrap: wrap;
`;

export const PolicyContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
`;

export const List = styled('div')`
  li {
    padding-left: ${Scale.s} !important;
  }
`;

export const BookablePricing = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
  align-items: flex-start;

  @media (min-width: ${breakpoints[Device.tablet]}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
  }
`;

export const Pricing = styled('div')`
  display: flex;
  gap: ${Scale.m};
  justify-content: space-between;
  align-items: flex-end;
`;

export const LeadRatePriceValue = styled(PriceValue)`
  // Override PriceValue font sizes.
  h4 {
    font-size: ${typographyVariantProperties[TypographyVariant.t4SansBold].tabletFontSize};
  }

  p {
    font-size: ${typographyVariantProperties[TypographyVariant.body].desktopFontSize};
  }
`;

export const StyledDiscountBadge = styled('div')`
  p {
    font-size: ${typographyVariantProperties[TypographyVariant.body].desktopFontSize};
  }
`;

export const ClickableInfoBox = styled('div')`
  cursor: pointer;
`;

export const RefundabilityBadgeWrapper = styled('div')`
  margin-top: ${Scale.m};
`;

export const ImageSkeleton = styled(LoadingSkeletonSection)`
  height: unset;
  aspect-ratio: 2 / 1;
`;
